import { createSelector } from "@reduxjs/toolkit";

export const selectBrochureUrl = (state) => state?.brochureDownloadUrl?.url;
export const selectBrochureFetchStatus = (state) => state?.brochureDownloadUrl?.fetchStatus;

/**
 * Combined selector to get both the brochure download URL and fetch status
 */
export const selectBrochureDetails = createSelector(
  [selectBrochureUrl, selectBrochureFetchStatus],
  (url, fetchStatus) => ({ url, fetchStatus }) 
);